import B from "./_Stack.js";
import d from "./_equalArrays.js";
import E from "./_equalByTag.js";
import S from "./_equalObjects.js";
import b from "./_getTag.js";
import x from "./isArray.js";
import "./isBuffer.js";
import D from "./isTypedArray.js";
import { i as L } from "../../_virtual/isBuffer.js";
var T = B, R = d, C = E, G = S, v = b, s = x, n = L.exports, M = D, $ = 1, O = "[object Arguments]", t = "[object Array]", o = "[object Object]", H = Object.prototype, w = H.hasOwnProperty;
function J(r, e, p, i, l, a) {
  var y = s(r), q = s(e), f = y ? t : v(r), _ = q ? t : v(e);
  f = f == O ? o : f, _ = _ == O ? o : _;
  var g = f == o, I = _ == o, A = f == _;
  if (A && n(r)) {
    if (!n(e))
      return !1;
    y = !0, g = !1;
  }
  if (A && !g)
    return a || (a = new T()), y || M(r) ? R(r, e, p, i, l, a) : C(r, e, f, p, i, l, a);
  if (!(p & $)) {
    var m = g && w.call(r, "__wrapped__"), u = I && w.call(e, "__wrapped__");
    if (m || u) {
      var P = m ? r.value() : r, j = u ? e.value() : e;
      return a || (a = new T()), l(P, j, p, i, a);
    }
  }
  return A ? (a || (a = new T()), G(r, e, p, i, l, a)) : !1;
}
var W = J;
export {
  W as default
};
//# sourceMappingURL=_baseIsEqualDeep.js.map
